"use strict";
// _tracking.js
// 初回訪問時のクエリパラメータとランディング情報を Cookie に保存する。
//   - どのページ（index / kasou / sougi / contact / hall 配下など）から入っても動作
//   - Cookie 名: sh_first_touch（1日間保持、初回のみ書き込み）
//   - PHP 側（mail.php の postToGas）が $_COOKIE から直接読むため、
//     JS で hidden input に詰め替える必要は無い。

(function () {
  var KEY = "sh_first_touch";

  var alreadySet = document.cookie.split("; ").some(function (c) {
    return c.indexOf(KEY + "=") === 0;
  });
  if (alreadySet) return;

  var params = {};
  try {
    new URLSearchParams(window.location.search).forEach(function (v, k) {
      params[k] = v;
    });
  } catch (_e) {
    // URLSearchParams 非対応ブラウザでは params を空で記録
  }

  var payload = {
    params: params,
    landing_url: window.location.href,
    landing_path: window.location.pathname,
    referrer: document.referrer || "",
    first_seen_at: new Date().toISOString(),
  };

  var expires = new Date(Date.now() + 1 * 24 * 60 * 60 * 1000).toUTCString();
  var secure = window.location.protocol === "https:" ? "; Secure" : "";

  document.cookie =
    KEY +
    "=" +
    encodeURIComponent(JSON.stringify(payload)) +
    "; expires=" +
    expires +
    "; path=/; SameSite=Lax" +
    secure;
})();
